import React from "react";
import "./About.css";
const skillGroups = [
  {
    title: "Frontend",
    blurb: "Interfaces, interactions, and everything users actually see.",
    skills: ["React.js", "JavaScript", "TypeScript", "HTML / CSS"],
  },
  {
    title: "Backend & APIs",
    blurb: "Keeping the logic, data, and endpoints running smoothly.",
    skills: ["Node.js", "SQL / MySQL / Oracle", "MongoDB"],
  },
  {
    title: "DevOps & Tools",
    blurb: "Shipping, debugging, and keeping projects alive in the wild.",
    skills: ["Docker", "Git / GitHub"],
  },
  {
    title: "Languages",
    blurb: "Other ecosystems I’ve worked and built projects in.",
    skills: ["Python", "C / C++ / C#"],
  },
];

const Skills = () => {
  return (
    <div className="skills-panel">
      <div className="skills-panel-header">
        <p className="skills-kicker">Skills</p>
        <h3 className="skills-title">Technical Snapshot</h3>
        <p className="skills-subtitle">
          The tools and stacks I reach for when I’m building, breaking, and
          shipping ideas into reality.
        </p>
      </div>

      <div className="skills-groups">
        {skillGroups.map((group) => (
          <div key={group.title} className="skills-group-card">
            <div className="skills-group-header">
              <h4 className="skills-group-title">{group.title}</h4>
              <p className="skills-group-blurb">{group.blurb}</p>
            </div>
            <div className="skills-chip-row">
              {group.skills.map((skill) => (
                <span key={skill} className="skill-chip">
                  <span className="skill-chip-dot" />
                  <span className="skill-chip-label">{skill}</span>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <p className="skills-footnote">
        * Always learning, always refactoring—this list grows with each new
        project.
      </p>
    </div>
  );
};

export default Skills;
